export default "__VITE_ASSET__f6b47f33__"